import { render, staticRenderFns } from "./OnboardingEmailFinal.vue?vue&type=template&id=f1f92f28&scoped=true&"
import script from "./OnboardingEmailFinal.vue?vue&type=script&lang=js&"
export * from "./OnboardingEmailFinal.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingEmailFinal.vue?vue&type=style&index=0&id=f1f92f28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f92f28",
  null
  
)

export default component.exports